import { render, staticRenderFns } from "./ButtonChevronFlippable.vue?vue&type=template&id=463f6e08&scoped=true&"
import script from "./ButtonChevronFlippable.vue?vue&type=script&lang=js&"
export * from "./ButtonChevronFlippable.vue?vue&type=script&lang=js&"
import style0 from "./ButtonChevronFlippable.vue?vue&type=style&index=0&id=463f6e08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463f6e08",
  null
  
)

export default component.exports